export const composeReducers = (...reducers) => {
  return (state, action) => {
    return reducers.reduce((acc, reducer) => reducer(acc, action), state)
  }
}
